export const getTrainingProgramSuggestionsAPI = "/training-program-suggestions";
export const getSuggestingStatusAPI = "/training-program-suggestions/status";
export const toggleSuggestingStatusAPI = "/training-program-suggestions/status";
